// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".fa-circle-question[data-v-2e38e4fb]{color:var(--q4s-accent)}.question-popover[data-v-2e38e4fb]{margin:-2px 5px 0 5px;z-index:9}", ""]);
// Exports
module.exports = exports;
